/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DefaultFormatTypeFromJSON, DefaultFormatTypeToJSON, } from './';
export function NumberFormatFromJSON(json) {
    return NumberFormatFromJSONTyped(json, false);
}
export function NumberFormatFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        format: json['format'],
        type: DefaultFormatTypeFromJSON(json['type']),
    };
}
export function NumberFormatToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        format: value.format,
        type: DefaultFormatTypeToJSON(value.type),
    };
}
